











import { Vue, Prop, Component } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
@Component({
  name: 'MainTitle',
  components: { Chart }
})
export default class extends Vue {
  @Prop({ default: '#00B66C' }) private color!: string

  @Prop() private standardData!: any
  @Prop() private data!: any

  private chartId: string = ''
  created() {
    this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
    this.option.series[0].data = this.data
    this.option.series[1].data = this.standardData
  }
  private option: any = {
    animation: false,
    title: {
      subtext: '占比（%）',
      top: 20
    },
    legend: {
      data: ['参考标准', '学员各分值区间占比'],
      right: 0,
      top: 30,
      icon: 'circle',
      itemWidth: 5
    },
    xAxis: [{
      type: 'category',
      axisTick: {
        show: false
      },
      data: ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100'],
      axisLine: {
        lineStyle: {
          color: '#AEAEAE'
        }
      },
      axisLabel: {
        color: '#666666'
      }
    }],
    yAxis: [{
      axisLabel: {
        color: '#666666'
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: '#AEAEAE'
        }
      },
      type: 'value',
      axisTick: {
        show: false
      },
      min: 0,
      max: 100,
      interval: 25
    },
    {
      type: 'value',
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      min: 0,
      interval: 25,
      max: 100
    }
    ],
    series: [{
      name: '学员各分值区间占比',
      type: 'bar',
      color: this.color,
      barWidth: 8,
      itemStyle: {
        barBorderRadius: 8
      },
      data: []
    },
    {
      name: '参考标准',
      type: 'line',
      yAxisIndex: 1,
      symbolSize: 0,
      color: '#666',
      lineStyle: {
        type: 'dotted'
      },
      smooth: true,
      data: []
    }
    ]
  }
}
